var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isAuthenticated)?_c('NavHeader',{staticClass:"d-print-none"}):_vm._e(),_c('v-content',{class:_vm.colorPage},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }